import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  TextField,
  InputAdornment,
  Checkbox,
  Typography,
} from '@material-ui/core';
import { Button } from 'merchant-portal-components';
import Box from '@material-ui/core/Box';
import SelectProductVariantsAndCombos from '../OfferEngineDetails/components/SelectProductVariantsAndCombos';
import { makeStyles } from '@material-ui/core/styles';
import { useContext } from 'react';
import { CustomizationContext } from '../../../utils/ClientCustomizationsProvider';
import { ApplyOfferTo } from './ApplyOfferTo';
import { set } from 'lodash';
import { useMemo } from 'react';
import { RewardsScanToPay } from './RewardsScanToPay';

const useStyles = makeStyles({
  noSpinners: {
    '& input[type=number]': {
      '-moz-appearance': 'textfield', // Firefox
    },
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none', // Chrome, Safari, Edge
      margin: 0,
    },
  },
});

const WrapperTop = styled.div`
  .mb25 {
    margin-bottom: 25px;
    min-width: 390px;
  }
`;
const TitleMain = styled.div`
  font-size: 21px;
  font-weight: 600;
  color: #191818;
`;
const NoteTextBold = styled.div`
  font-size: 14px;
  color: #191818;
  margin-bottom: 10px;
  font-weight: 600;
`;
const WrapperInnerMain = styled.div`
  padding-left: 15px;
`;
const Wrapper = styled.div`
  display: grid;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: ${(props) =>
    props.isLastItem ? 'none' : '2px solid #000000'};
`;
const WrapperInner = styled.div`
  display: grid;
  align-items: center;
  margin-left: 30px;
`;
const Subtitle = styled.div`
  font-size: 21px;
  font-weight: 600;
  letter-spacing: 0.03px;
  color: #191818;
`;
const FullWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 65px;
  align-items: center;
  margin-bottom: 15px;
  .formSection {
    display: grid;
  }
`;
const FullWrapperNonFlex = styled.div`
  display: block;
  margin-bottom: 15px;
  padding-left: 10px;

  .formSection {
    display: grid;
  }
`;
const NoteText = styled.div`
  font-size: 14px;
  color: #191818;
  margin-bottom: 10px;
`;
const NoteHead = styled.div`
  font-size: 17px;
  color: #191818;
  font-weight: 600;
  margin-bottom: 5px;
`;
const NoteHeadNormal = styled.span`
  font-size: 17px;
  color: #191818;
  font-weight: normal;
`;
const SubHead = styled.div`
  font-size: 17px;
  color: #191818;
  font-weight: 600;
  margin-bottom: 15px;
`;

const WrapperInside = styled.div`
  /* border-bottom: 1px solid #e1e1e1; */
  padding-bottom: 10px;
  padding-top: 10px;
  .addProduct {
    background: none;
    /* border: 0px; */
    font-size: 15px;
    font-weight: 600;
    margin-top: 20px;
    cursor: pointer;
    margin-bottom: 10px;
  }
`;
const NoteInside = styled.div`
  padding-left: 15px;
  font-size: 15px;
  font-weight: 600;
  margin-top: 10px;
  margin-bottom: 10px;
`;
const ActionBox = styled.div`
  display: flex;
  padding-left: 15px;
  max-width: 120px;
`;

const SubNoteInside = styled.div`
  padding-left: 15px;
  font-size: 12px;
  margin-top: -10px;
  margin-bottom: 10px;
`;
const CheckboxWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 50px;
  align-items: center;
`;
const FlexWrapper = styled.div`
  width: ${(props) => (props) => props.width || '110px'};
  grid-gap: 30px;
`;

const FlexWrapperFloat = styled.div`
  width: ${(props) => (props) => props.width || '110px'};
  align-items: center;
`;
const AdornmentIcon = styled.i`
  color: #bdbdbd;
  font-size: ${(props) => props.size || '15px'};
  margin: ${(props) => props.margin || 0};
`;
const ErrorSpan = styled.div`
  color: red;
  font-size: 12px;
`;
const CopyButtonWrapper = styled.div`
  margin: 10px 0;
  display: flex;
  justify-content: flex-end;
`;
const RewardDetails = ({
  values,
  setFieldValue,
  allProductVariants,
  errors,
  title,
  indexItem,
  // posMappingStringValue,
  // posMappingStringValueCombos,
  // setPosMappingStringValue,
  // setPosMappingStringValueCombos,
  isLastItemInTheCard,
  handleCopyRewards,
  source,
  selectedOfferTypes,
  setSelectedOfferTypes,
}) => {
  const classes = useStyles();
  const handleWheel = (e) => {
    e.target.blur(); // Prevent scroll wheel input
  };

  const [isComboSelected, setIsComboSelected] = useState(false);
  const [isProductSelected, setIsProductSelected] = useState(false);
  const handleKeyDown = (e) => {
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault(); // Prevent arrow key input
    }
  };
  const productIndex =
    values.conditionValue[indexItem]?.rewards?.products?.length > 0
      ? values.conditionValue[indexItem]?.rewards?.products?.findIndex(
          (x) => x['product'] != undefined
        )
      : 0;
  const currentSource = values?.conditionValue[indexItem]?.source;
  const isScanToPay = !['web', 'mobile'].includes(currentSource);
  // e.g. in the future
  const separateComboPOSList = ['QUICKSERVICE', 'SOME_OTHER_POS'];
  const shouldShowSeparateCombos = separateComboPOSList.includes(currentSource);

  // const isScanToPay = true;
  const [posMappingStringValue, setPosMappingStringValue] = useState('');
  const [posMappingStringValueCombos, setPosMappingStringValueCombos] =
    useState('');
  const [isOpen, setIsOpen] = useState(false);
  // state for combo selection filter
  const [isComboSelectionFilterOpen, setIsComboSelectionFilterOpen] =
    useState(false);
  const handleOpenComboVariantsModal = () => {
    setIsComboSelectionFilterOpen(true);
  };
  const [isAllProductsSelected, setIsAllProductsSelected] = useState(false);
  const handleOpenProductVariantsModal = () => {
    setIsOpen(true);
  };

  const updateLocalstate = (source) => {
    const conditionFrom = values.conditionValue.find(
      (condition) => condition.source === source
    );

    if (!conditionFrom) return;

    const getJoinedIds = (arr, key) =>
      (arr || [])
        .map((item) => item[key])
        .filter(Boolean)
        .join(',');

    setPosMappingStringValue(
      getJoinedIds(conditionFrom.reward.products, 'product_id')
    );

    setPosMappingStringValueCombos(
      getJoinedIds(conditionFrom.reward.combos, 'combo_id')
    );
  };

  useEffect(() => {
    let count = 0;
    allProductVariants?.forEach((product) => {
      if (product.prices?.length > 0) {
        product.prices.forEach((variant) => count++);
      } else {
        count++;
      }
    });
    const mappedProductVariants = values.conditionValue[indexItem]?.reward
      ? values.conditionValue[indexItem]?.reward?.products
      : [];
    if (
      count === mappedProductVariants?.length ||
      mappedProductVariants?.length === 0
    ) {
      setIsAllProductsSelected(true);
    } else {
      setIsAllProductsSelected(false);
    }
  }, [values.conditionValue[0]?.reward?.products, allProductVariants]);
  const handleUpdateProducts = (products) => {
    // values.conditionValue.forEach((_, i) => {
    // });
    setFieldValue(`conditionValue[${indexItem}].reward.products`, products);
  };
  const handleUpdateCombos = (combos) => {
    // values.conditionValue.forEach((_, i) => {
    // });
    setFieldValue(`conditionValue[${indexItem}].reward.combos`, combos);
  };
  useEffect(() => {
    if (values.products && values.products.length > 0) {
      // delete the field if it has values
      setFieldValue(`conditionValue[${indexItem}].reward.products`, undefined);
    }
    if (values.combos && values.combos.length > 0) {
      // delete the field if it has values
      setFieldValue(`conditionValue[${indexItem}].reward.combos`, undefined);
    }
  }, [values.products, values.combos]);

  const [
    isAllProductsPOSMappingIDsSelected,
    setIsAllProductsPOSMappingIDsSelected,
  ] = useState(false);
  const [
    isAllCombosPOSMappingIDsSelected,
    setIsAllCombosPOSMappingIDsSelected,
  ] = useState(false);

  useEffect(() => {
    if (
      values.conditionValue.length > 0 &&
      !['web', 'mobile'].includes(values.conditionValue[indexItem]?.source)
    ) {
      let posMappingString = [];
      if (
        values.conditionValue[indexItem]?.reward.products?.length === 0 &&
        values.offer_details.template_name !== 'free-item'
      ) {
        setIsAllProductsPOSMappingIDsSelected(true);
      } else {
        posMappingString = JSON.stringify(
          values.conditionValue[indexItem]?.reward.products?.map(
            (pro) => pro.product_id
          )
        );
        posMappingString = posMappingString?.substring(
          1,
          posMappingString.length - 1
        );
        setIsAllProductsPOSMappingIDsSelected(false);
      }
      posMappingString =
        posMappingString && typeof posMappingString === 'string'
          ? posMappingString?.replaceAll('"', '')
          : posMappingString;
      setPosMappingStringValue(posMappingString);
    }
  }, [indexItem]);
  useEffect(() => {
    if (
      values.conditionValue.length > 0 &&
      !['web', 'mobile'].includes(values.conditionValue[indexItem]?.source)
    ) {
      let posMappingString = [];
      if (
        values.conditionValue[indexItem]?.reward.combos?.length === 0 &&
        values.offer_details.template_name !== 'free-item'
      ) {
        setIsAllProductsPOSMappingIDsSelected(true);
      } else {
        posMappingString = JSON.stringify(
          values.conditionValue[indexItem]?.reward.combos?.map(
            (pro) => pro.combo_id
          )
        );
        posMappingString = posMappingString?.substring(
          1,
          posMappingString.length - 1
        );
        setIsAllProductsPOSMappingIDsSelected(false);
      }
      posMappingString =
        posMappingString && typeof posMappingString === 'string'
          ? posMappingString?.replaceAll('"', '')
          : posMappingString;
      setPosMappingStringValueCombos(posMappingString);
    }
  }, [indexItem]);
  const handleChangeIDs = (e, setFieldValue, indexItem, key = 'products') => {
    const field = e.target.name;
    let value = e.target.value;

    const filedValue = value
      .trim()
      .replace(/[\s,]+/g, ',')
      .split(',')
      .filter(Boolean);

    const idKey = key === 'combos' ? 'combo_id' : 'product_id';

    const formattedFieldValue = filedValue.map((item) => ({
      [idKey]: item,
    }));

    setFieldValue(field, formattedFieldValue);

    if (key === 'combos') {
      setPosMappingStringValueCombos(value);
    } else {
      setPosMappingStringValue(value);
    }
  };

  const handleComboSelection = (e) => {
    setIsComboSelected(e.target.checked);
  };
  const handleProductSelection = (e) => {
    setIsProductSelected(e.target.checked);
  };

  const handleOfferTypeChange = (value, type) => {
    if (type === 'all_menu') {
      setFieldValue(`conditionValue[${indexItem}].reward.products`, []);
      setFieldValue(`conditionValue[${indexItem}].reward.combos`, []);
    } else if (type === 'products') {
      if (!value[currentSource].includes('products')) {
        setFieldValue(
          `conditionValue[${indexItem}].reward.products`,
          undefined
        );
      } else {
        const newValue =
          values.offer_details.template_name === 'first-time' ||
          values.offer_details.template_name === 'fixed-price'
            ? null
            : [];
        setFieldValue(`conditionValue[${indexItem}].reward.products`, null);
      }
    } else if (type === 'combos') {
      if (!value[currentSource].includes('combos')) {
        setFieldValue(`conditionValue[${indexItem}].reward.combos`, undefined);
      } else {
        const newValue =
          values.offer_details.template_name === 'first-time' ||
          values.offer_details.template_name === 'fixed-price'
            ? null
            : [];
        setFieldValue(`conditionValue[${indexItem}].reward.combos`, null);
      }
    }
    setSelectedOfferTypes(value);
  };

  useEffect(() => {
    const currentTypes = { ...selectedOfferTypes };
    // products
    if (
      values.conditionValue[indexItem]?.reward?.products &&
      currentTypes?.[currentSource]?.includes('products') === false
    ) {
      currentTypes[currentSource] = [
        ...(currentTypes[currentSource] || []),
        'products',
      ];
      setSelectedOfferTypes(currentTypes);
    }
    if (
      values.conditionValue[indexItem]?.reward?.products?.length === 0 &&
      isScanToPay
    ) {
      setIsAllProductsPOSMappingIDsSelected(true);
    }

    // combos
    if (
      values.conditionValue[indexItem]?.reward?.combos &&
      currentTypes?.[currentSource]?.includes('combos') === false
    ) {
      currentTypes[currentSource] = [
        ...(currentTypes[currentSource] || []),
        'combos',
      ];
      setSelectedOfferTypes(currentTypes);
    }
    if (
      values.conditionValue[indexItem]?.reward?.combos?.length === 0 &&
      isScanToPay
    ) {
      setIsAllCombosPOSMappingIDsSelected(true);
    }
  }, [
    values.conditionValue[indexItem]?.reward?.products,
    values.conditionValue[indexItem]?.reward?.combos,
    selectedOfferTypes,
  ]);
  const isQuickServiceProductsNotVisible =
    !selectedOfferTypes?.['quickservice']?.includes('products') &&
    currentSource === 'quickservice';

  const isQuickServiceCombosNotVisible =
    !selectedOfferTypes?.['quickservice']?.includes('combos') &&
    currentSource === 'quickservice';

  const shouldDisplayApplyOfferDropdown = useMemo(() => {
    if (
      values.offer_details.template_name !== 'first-time' &&
      values.offer_details.template_name !== 'carryover-loyalty' &&
      ['web', 'mobile', 'quickservice'].includes(currentSource)
    ) {
      return true;
    }
    return false;
  }, [values.offer_details.template_name]);
  return (
    <WrapperTop>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 2,
        }}
      >
        <TitleMain>{title}</TitleMain>
        {['web', 'mobile'].includes(source) && title !== 'Scan (POS)' && (
          <CopyButtonWrapper>
            <Button
              onClick={() => {
                handleCopyRewards(
                  title === 'Web' ? 'mobile' : 'web',
                  indexItem
                );
                updateLocalstate(title === 'Web' ? 'mobile' : 'web', indexItem);
              }}
            >
              {values.conditionValue[indexItem]?.source === 'web'
                ? 'Copy From Mobile'
                : 'Copy From Web'}
            </Button>
          </CopyButtonWrapper>
        )}
      </Box>
      <Wrapper isLastItem={isLastItemInTheCard}>
        <WrapperInside>
          {/* Text Fields */}
          {values.offer_details.template_name === 'first-time' && (
            <FullWrapper>
              <div className='formSection'>
                <NoteHead>
                  Maximum dollar amount that can be discounted per redemption
                </NoteHead>
                <FlexWrapper>
                  <TextField
                    id='outlined-basic'
                    type='number'
                    className={classes.noSpinners}
                    onWheel={handleWheel}
                    onKeyDown={handleKeyDown}
                    label=''
                    variant='outlined'
                    placeholder='12.00'
                    value={values.conditionValue[indexItem]?.reward?.amount}
                    onChange={(e) => {
                      setFieldValue(
                        `conditionValue[${indexItem}].reward.amount`,
                        parseFloat(e.target.value)
                      );
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position='start'>
                          <AdornmentIcon
                            className='fa fa-dollar-sign'
                            size='17px'
                          ></AdornmentIcon>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {errors?.conditionValue &&
                    errors?.conditionValue[indexItem]?.reward?.amount && (
                      <ErrorSpan>
                        {errors?.conditionValue[indexItem]?.reward?.amount}
                      </ErrorSpan>
                    )}
                </FlexWrapper>
              </div>
            </FullWrapper>
          )}
          {values.offer_details.template_name === 'free-item' && (
            <FullWrapper>
              <div className='formSection'>
                <NoteHead>
                  Maximum dollar amount that can be discounted per redemption
                </NoteHead>
                <FlexWrapper>
                  <TextField
                    id='outlined-basic'
                    className={classes.noSpinners}
                    onWheel={handleWheel}
                    onKeyDown={handleKeyDown}
                    type='number'
                    label=''
                    variant='outlined'
                    placeholder='12.00'
                    value={values.conditionValue[indexItem]?.reward?.amount}
                    onChange={(e) => {
                      setFieldValue(
                        `conditionValue[${indexItem}].reward.amount`,
                        parseFloat(e.target.value)
                      );
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position='start'>
                          <AdornmentIcon
                            className='fa fa-dollar-sign'
                            size='17px'
                          ></AdornmentIcon>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {errors?.conditionValue &&
                    errors?.conditionValue[indexItem]?.reward?.amount && (
                      <ErrorSpan>
                        {errors?.conditionValue[indexItem]?.reward?.amount}
                      </ErrorSpan>
                    )}
                </FlexWrapper>
              </div>
            </FullWrapper>
          )}
          {values.offer_details.template_name === 'discounted-item' && (
            <FullWrapper>
              <div className='formSection'>
                <NoteHead>Percentage discount amount</NoteHead>
                <FlexWrapperFloat width='160px'>
                  <TextField
                    id='outlined-basic'
                    type='number'
                    label=''
                    variant='outlined'
                    className={classes.noSpinners}
                    onWheel={handleWheel}
                    onKeyDown={handleKeyDown}
                    placeholder='30'
                    value={values.conditionValue[indexItem]?.reward?.amount}
                    onChange={(e) => {
                      setFieldValue(
                        `conditionValue[${indexItem}].reward.amount`,
                        parseFloat(e.target.value)
                      );
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <AdornmentIcon
                            className='fa fa-percent'
                            margin='0 5px 0 0'
                            size='13px'
                          ></AdornmentIcon>
                          <span style={{ color: '#bdbdbd' }}>off</span>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {errors?.conditionValue &&
                    errors?.conditionValue[indexItem]?.reward?.amount && (
                      <ErrorSpan>
                        {errors?.conditionValue[indexItem]?.reward?.amount}
                      </ErrorSpan>
                    )}
                </FlexWrapperFloat>
              </div>
            </FullWrapper>
          )}
          {values.offer_details.template_name === 'fixed-price' && (
            <FullWrapper>
              <div className='formSection'>
                <NoteHead>Amount</NoteHead>
                <FlexWrapperFloat width='160px'>
                  <TextField
                    id='outlined-basic'
                    type='number'
                    label=''
                    variant='outlined'
                    className={classes.noSpinners}
                    onWheel={handleWheel}
                    onKeyDown={handleKeyDown}
                    placeholder='30'
                    value={values.conditionValue[indexItem]?.reward?.amount}
                    onChange={(e) => {
                      setFieldValue(
                        `conditionValue[${indexItem}].reward.amount`,
                        parseFloat(e.target.value)
                      );
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <AdornmentIcon
                            className='fa fa-dollar-sign'
                            margin='0 5px 0 0'
                            size='13px'
                          ></AdornmentIcon>
                          {/* <span style={{ color: '#bdbdbd' }}>amount</span> */}
                        </InputAdornment>
                      ),
                    }}
                  />
                  {errors?.conditionValue &&
                    errors?.conditionValue[indexItem]?.reward?.amount && (
                      <ErrorSpan>
                        {errors?.conditionValue[indexItem]?.reward?.amount}
                      </ErrorSpan>
                    )}
                </FlexWrapperFloat>
              </div>
            </FullWrapper>
          )}
          {values.offer_details.template_name === 'dollar-discount' && (
            <FullWrapper>
              <div className='formSection'>
                <NoteHead>Dollar discount amount</NoteHead>
                <FlexWrapper>
                  <TextField
                    id='outlined-basic'
                    type='number'
                    label=''
                    variant='outlined'
                    className={classes.noSpinners}
                    onWheel={handleWheel}
                    onKeyDown={handleKeyDown}
                    placeholder='12.00'
                    value={values.conditionValue[indexItem]?.reward?.amount}
                    onChange={(e) => {
                      setFieldValue(
                        `conditionValue[${indexItem}].reward.amount`,
                        parseFloat(e.target.value)
                      );
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position='start'>
                          <AdornmentIcon
                            className='fa fa-dollar-sign'
                            size='17px'
                          ></AdornmentIcon>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {errors?.conditionValue &&
                    errors?.conditionValue[indexItem]?.reward?.amount && (
                      <ErrorSpan>
                        {errors?.conditionValue[indexItem]?.reward?.amount}
                      </ErrorSpan>
                    )}
                </FlexWrapper>
              </div>
            </FullWrapper>
          )}
          {values.offer_details.template_name === 'bonus-points' && (
            <FullWrapper>
              <div className='formSection'>
                <NoteHead>Bonus points amount</NoteHead>
                <FlexWrapper width='160px'>
                  <TextField
                    id='outlined-basic'
                    type='number'
                    label=''
                    variant='outlined'
                    className={classes.noSpinners}
                    onWheel={handleWheel}
                    onKeyDown={handleKeyDown}
                    placeholder='12'
                    value={values.conditionValue[indexItem]?.reward?.amount}
                    onChange={(e) => {
                      // values.conditionValue.forEach((_, i) => {});
                      setFieldValue(
                        `conditionValue[${indexItem}].reward.amount`,
                        parseFloat(e.target.value)
                      );
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>points</InputAdornment>
                      ),
                    }}
                  />
                  {errors?.conditionValue &&
                    errors?.conditionValue[indexItem]?.reward?.amount && (
                      <ErrorSpan>
                        {errors?.conditionValue[indexItem]?.reward?.amount}
                      </ErrorSpan>
                    )}
                </FlexWrapper>
              </div>
            </FullWrapper>
          )}
          {values.offer_details.template_name === 'points-multiplier' && (
            <FullWrapper>
              <div className='formSection'>
                <NoteHead>Points Multiply By </NoteHead>
                <FlexWrapper width='110px'>
                  <TextField
                    id='outlined-basic'
                    type='number'
                    label=''
                    variant='outlined'
                    className={classes.noSpinners}
                    onWheel={handleWheel}
                    onKeyDown={handleKeyDown}
                    placeholder='e.g 2'
                    value={values.conditionValue[indexItem]?.reward?.amount}
                    onChange={(e) => {
                      const val = parseFloat(e.target.value);
                      if (val >= 1)
                        setFieldValue(
                          `conditionValue[${indexItem}].reward.amount`,
                          parseFloat(e.target.value)
                        );
                    }}
                  />
                  {errors?.conditionValue &&
                    errors?.conditionValue[indexItem]?.reward?.amount && (
                      <ErrorSpan>
                        {errors?.conditionValue[indexItem]?.reward?.amount}
                      </ErrorSpan>
                    )}
                </FlexWrapper>
              </div>
            </FullWrapper>
          )}
          {values.offer_details.template_name === 'carryover-loyalty' && (
            <FullWrapper>
              <div className='formSection'>
                <NoteHead>
                  Maximum dollar amount that can be discounted per redemption
                </NoteHead>
                <FlexWrapper>
                  <TextField
                    id='outlined-basic'
                    type='number'
                    label=''
                    variant='outlined'
                    className={classes.noSpinners}
                    onWheel={handleWheel}
                    onKeyDown={handleKeyDown}
                    placeholder='12.00'
                    value={values.conditionValue[indexItem]?.reward?.amount}
                    onChange={(e) => {
                      setFieldValue(
                        `conditionValue[${indexItem}].reward.amount`,
                        parseFloat(e.target.value)
                      );
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position='start'>
                          <AdornmentIcon
                            className='fa fa-dollar-sign'
                            size='17px'
                          ></AdornmentIcon>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {errors?.conditionValue &&
                    errors?.conditionValue[indexItem]?.reward?.amount && (
                      <ErrorSpan>
                        {errors?.conditionValue[indexItem]?.reward?.amount}
                      </ErrorSpan>
                    )}
                </FlexWrapper>
              </div>
            </FullWrapper>
          )}
          {/* Apply Offer To Component */}
          {shouldDisplayApplyOfferDropdown && (
            <Box sx={{ my: 2 }}>
              <ApplyOfferTo
                selectedOffers={selectedOfferTypes}
                onOfferChange={handleOfferTypeChange}
                notShowAllMenu={
                  values.offer_details.template_name === 'free-item' ||
                  values.offer_details.template_name === 'fixed-price'
                }
                currentSource={currentSource}
              />
            </Box>
          )}
          <div style={{ marginBottom: '20px' }}>
            {values.conditionValue[indexItem]?.reward &&
              values.offer_details.template_name !== 'first-time' &&
              values?.offer_details?.template_name !== 'carryover-loyalty' && (
                <>
                  {isScanToPay ? (
                    <RewardsScanToPay
                      values={values}
                      currentSource={currentSource}
                      setFieldValue={setFieldValue}
                      indexItem={indexItem}
                      posMappingStringValue={posMappingStringValue}
                      handleChangeIDs={handleChangeIDs}
                      isAllProductsPOSMappingIDsSelected={
                        isAllProductsPOSMappingIDsSelected
                      }
                      setIsAllProductsPOSMappingIDsSelected={
                        setIsAllProductsPOSMappingIDsSelected
                      }
                      posMappingStringValueCombos={posMappingStringValueCombos}
                      handleChangeIDsCombos={handleChangeIDs}
                      isAllCombosPOSMappingIDsSelected={
                        isAllCombosPOSMappingIDsSelected
                      }
                      setIsAllCombosPOSMappingIDsSelected={
                        setIsAllCombosPOSMappingIDsSelected
                      }
                      selectedOfferTypes={selectedOfferTypes}
                      isQuickServiceProductsNotVisible={
                        isQuickServiceProductsNotVisible
                      }
                      isQuickServiceCombosNotVisible={
                        isQuickServiceCombosNotVisible
                      }
                    />
                  ) : (
                    <SelectProductVariantsAndCombos
                      values={values}
                      setFieldValue={setFieldValue}
                      indexItem={indexItem}
                      isEmptyEqualAll={
                        values.offer_details.template_name !== 'free-item' ||
                        values.offer_details.template_name !==
                          'SelectProductVariantsAndCombos'
                      }
                      isEmptyAcceptable={
                        values.offer_details.template_name !== 'free-item' ||
                        values.offer_details.template_name !==
                          'SelectProductVariantsAndCombos'
                      }
                      selectedOfferTypes={selectedOfferTypes}
                      currentSource={currentSource}
                    />
                  )}
                </>
              )}

            {isOpen && (
              <FilterProductVariantsModal
                placeholder='Enter Product/Variants Name'
                searchLabel='Search by Product/Variants Name'
                filteredProducts={
                  values.conditionValue[indexItem]?.reward?.products
                }
                setFilteredProducts={handleUpdateProducts}
                isAllProductsSelected={isAllProductsSelected}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                // formField={formKey}
                emptyIsEqualToAll={
                  values.offer_details.template_name !== 'free-item' ||
                  values.offer_details.template_name !== 'fixed-price'
                }
                isEmptyAccepted={true}
              />
            )}
          </div>
        </WrapperInside>
      </Wrapper>
    </WrapperTop>
  );
};
export default RewardDetails;
